import { JOVE_PRICE_UNIT_PERCENT_KEY } from '../../constants/common';
export var generateBrokerEntityInitialDataInfo = function generateBrokerEntityInitialDataInfo(data) {
  var _ref = data || {},
      broker_fee = _ref.broker_fee,
      broker_commission_fee = _ref.broker_commission_fee,
      broker_commission_fee_type = _ref.broker_commission_fee_type,
      partnerType = _ref.partnerType,
      broker_fee_type = _ref.broker_fee_type,
      broker_underwriting_fee = _ref.broker_underwriting_fee,
      broker_underwriting_fee_type = _ref.broker_underwriting_fee_type,
      broker_underwriting_fee_cap = _ref.broker_underwriting_fee_cap,
      subBrokerType = _ref.subBrokerType,
      payload = _ref.payload;

  var _ref2 = payload || {},
      commission_rate_effective_date = _ref2.commission_rate_effective_date,
      apply_commission_from_inception = _ref2.apply_commission_from_inception;

  return {
    legalEntityCountry: null,
    brokerPlatform: '',
    countryBrokerId: '',
    legalEntityName: '',
    fcaLicenseNumber: '',
    insuranceLicenseNumber: '',
    companyNumber: '',
    companyOfficeId: '',
    taxNumber: '',
    streetAddress: '',
    houseNumber: '',
    flatNumber: '',
    zipCode: '',
    city: '',
    contactFirstName: '',
    contactLastName: '',
    contactJobTitle: '',
    contactEmail: '',
    contactPhone: '',
    isTheSigner: true,
    signUserFirstName: '',
    signUserLastName: '',
    signUserJobTitle: '',
    signUserEmail: '',
    signUserPhone: '',
    signUserInviteMessage: '',
    operateCountries: [],
    confirmPassport: true,
    documentList: [],
    regulatedBodyName: '',
    brokerCommission: !subBrokerType ? broker_commission_fee || null : null,
    brokerCommissionUnit: broker_commission_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    brokerFee: !subBrokerType ? broker_fee || null : null,
    brokerFeeUnit: broker_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    partnerType: partnerType || null,
    underwritingFee: !subBrokerType ? broker_underwriting_fee || 0 : 0,
    underwritingFeeUnit: broker_underwriting_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    underwritingFeeCap: !subBrokerType ? broker_underwriting_fee_cap || 0 : 0,
    skipSetCommission: false,
    allowDirectPayWithoutRules: false,
    commissionRateEffectiveDate: commission_rate_effective_date || null,
    applyCommissionFromInception: !!apply_commission_from_inception
  };
};